/**
 * 过滤器
 *
 * @date: 2019-07-11
 * @author: chenyongzheng
 */
// 引入moment
import moment from 'moment'

/**
 * 时间YYYYMMDD  过滤器
 *
 * @param val
 * @returns {string}
 */
const TIME_YYYYMMDD_FILTER = val => {
    if (!val) {
        return '';
    }
    return moment(val).format('YYYY-MM-DD');
}
/**
 * 性别过滤器
 * @param val
 * @returns {string}
 * @constructor
 */

const SEX_FILTER = val => {
    switch (val) {
        case 1:
            return '男';
        case 2:
            return '女';
    }
}

const POSITION_FILTER = val => {
    switch (val) {
        case 99:
            return '管理员';
        case 88:
            return '领导';
        case 1:
            return '库管员';
        case 2:
            return '内检员';
        case 3:
            return '送货员';
        case 4:
            return '司机';
        case 5:
            return '厂家联系人';
    }
}

const CODE_FILTER = val => {
    switch (val) {
        case 1:
            return '使用方式';
        case 2:
            return '装备种类';
        case 31:
            return '装备样式-高炮';
        case 32:
            return '装备样式-火箭发射架';
        case 33:
            return '装备样式-焰条播撒器';
        case 34:
            return '装备样式-焰弹发射器';
        case 4:
            return '催化剂种类';
        case 5:
            return '弹药样式';
        case 6:
            return '分类码';
    }
}
/**
 * 24小时制 时间过滤器
 *
 * @param val
 * @returns {string}
 */
const timeHHFilter = val => {
    if (!val) {
        return '';
    }
    return moment(val).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * 头像/昵称转码
 *
 * @param val
 * @returns {string}
 */
const uncodeUtf16Filter = val => {
    if (val == null || val == '') {
        return '-';
    }
    let str = val;
    let reg = /\&#.*?;/g;
    let result = str.replace(reg, function (char) {
        let H, L, code;
        if (char.length == 9) {
            code = parseInt(char.match(/[0-9]+/g));
            H = Math.floor((code - 0x10000) / 0x400) + 0xD800;
            L = (code - 0x10000) % 0x400 + 0xDC00;
            return unescape("%u" + H.toString(16) + "%u" + L.toString(16));
        } else {
            return char;
        }
    });
    return result;
}

/**
 * 金钱格式化
 * @param value
 * @returns {string}
 */
const formatMoney = (value) => {
    if (value >= 0) {
        const money = Number(value)
        return '￥ ' + money.toFixed(2) + ' 元'
    }
}
const enableStatusFormat = val => {
    switch (val) {
        case 0:
            return '启用'
        case 1:
            return '禁用'
    }
}
const auditStatusFormat = val => {
    switch (val) {
        case 0:
            return '通过'
        case 1:
            return '待审核'
        case 2:
            return '驳回'
    }
}
const paymentStatusFormat = val => {
    switch (val) {
        case 1:
            return '待审核';
            break
        case 2:
            return '已开通';
            break
        case 3:
            return '已驳回';
            break
        default :
            return '-';
    }
};

const isEditFormat = (isEdit) => {
    if (isEdit === true) {
        return '编辑'
    } else {
        return '新增'
    }
}
const merchantTypeFormat = val => {
    switch (val) {
        case 1:
            return '企业'
        case 3:
            return '企业'
    }
}

export function enterpriseTypeFilter(type) {
    switch (type) {
        case 1:
            return '企业账户'
        case 2:
            return '企业法人账户'
    }
}

// 角色列表启用状态,0启用，1禁用
const roleStateFilter = val => {
    switch (val) {
        case 0:
            return '启用'
        case 1:
            return '禁用'
    }
}

const openBank = val => {
    switch (val) {
        case '01040000':
            return '中国银行'
        case '01020000':
            return '中国工商银行'
        case '01030000':
            return '中国农业银行'
        case '01050000':
            return '中国建设银行'
        case '03020000':
            return '中信银行'
        case '03030000':
            return '中国光大银行'
        case '03060000':
            return '广东发展银行'
        case '03080000':
            return '招商银行'
        case '03100000':
            return '上海浦东发展银行'
        case '03090000':
            return '兴业银行'
        case '03050000':
            return '民生银行'
        case '03160000':
            return '浙商银行'
        case '03170000':
            return '渤海银行'
        case '03010000':
            return '交通银行'
        case '03040000':
            return '华夏银行'
        case '01000000':
            return '中国邮政储蓄银行'
    }
}

/**
 * 订单状态
 * @param val
 * @returns {string}
 */
const orderStatusFilter = val => {
    switch (val) {
        case 0:
            return '待付款'
        case 1:
            return '待发货'
        case 2:
            return '待收货'
        case 3:
            return '已收货'
        case 4:
            return '已完成'
        case 5:
            return '已关闭'
        case 6:
            return '已取消'
        default:
            return '-'
    }
}

/**
 * 订单类型
 * @param val
 * @returns {string}
 */
const orderTypeFilter = val => {
    switch (val) {
        case 1:
            return '门店订单'
        case 2:
            return '严选订单'
    }
}
const trxType = val => {
    let str = ''
    switch (val) {
        case '1':
            str = '提现'
            break
        case '2':
            str = '提现手续费'
            break
        case '3':
            str = '用户下单支付手续费'
            break
        case '4':
            str = '排位推广'
            break
        case '5':
            str = '排位晋级'
            break
        case '6':
            str = '卖赚收入'
            break
        case '7':
            str = '提现失败返还'
            break
        case '8':
            str = '提现手续费返还'
            break
        case '9':
            str = '源头分佣'
            break
        case '10':
            str = '运费'
            break
        case '11':
            str = '商品金额'
            break
        case '12':
            str = '充值'
            break
        default:
            str = ''
    }
    return str
}
const accountTypeFilter = val => {
    let str = ''
    switch (val) {
        case 1:
            str = '企业'
            break
        case 2:
            str = '个体户'
            break
        case 3:
            str = '个人'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 用户类型
 * @param val
 * @returns {string}
 * @constructor
 */
const CheckUserType = val => {
    let str = ''
    val = parseInt(val)
    switch (val) {
        case 1:
            str = '会员'
            break
        case 2:
            str = '商户'
            break
        case 3:
            str = '供应商'
            break
        case 4:
            str = '业务平台'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 商户类型
 * @param val
 * @returns {string}
 */
const merchantClassifyFilter = val => {
    let str = ''
    switch (val) {
        case 1:
            str = '企业'
            break
        case 3:
            str = '个人'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 提现状态
 * @param val
 * @returns {string}
 */
const withdrawalFilter = val => {
    let str = ''
    switch (val) {
        case 0:
            str = '审核中'
            break
        case 1:
            str = '已完成'
            break
        case 2:
            str = '已失败'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 启用状态
 * @param val
 * @returns {string}
 */
const initiateStatusFilter = val => {
    let str = ''
    switch (val) {
        case 0:
            str = '启用'
            break
        case 1:
            str = '禁用'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 审核状态
 * @param val
 * @returns {string}
 */
const changeAuditStatusFilter = val => {
    let str = ''
    switch (val) {
        case 0:
            str = '通过'
            break
        case 1:
            str = '待审核'
            break
        case 2:
            str = '驳回'
            break
        default:
            str = ''
    }
    return str
}

/**
 * 账户类型
 * @param val
 * @returns {string}
 */
const assuringBankTypeFilter = val => {
    let str = ''
    switch (val) {
        case 1:
            str = '企业账户'
            break
        case 2:
            str = '企业法人账户'
            break
        default:
            str = ''
    }
    return str
}

//订单状态
const orderStatusOptionsFilter = val => {
    let str = ''
    switch (val) {
        case 0:
            str = '待付款'
            break
        case 1:
            str = '待发货'
            break
        case 2:
            str = '待收货'
            break
        case 3:
            str = '已收货'
            break
        case 4:
            str = '已完成'
            break
        case 5:
            str = '已关闭'
            break
        case 6:
            str = '已取消'
            break
        default:
            str = ''
    }
    return str
}
// 广告
const adTypeList = val => {
    let str = ''
    val = parseInt(val)
    switch (val) {
        case 1:
            str = 'banner广告'
            break
        case 2:
            str = '商品广告'
            break
        default:
            str = ''
    }
    return str
}



// 退货原因
const returnReasonFilter = val => {
    let str = ''
    switch (val) {
        case 1:
            str = '买多'
            break
        case 2:
            str = '不想要了'
            break
        case 3:
            str = '媳妇让退货'
            break
        default:
            str = ''
    }
    return str
}

export default {
    TIME_YYYYMMDD_FILTER,
    SEX_FILTER,
    POSITION_FILTER,
    CODE_FILTER
}



// WEBPACK FOOTER //
// ./src/utils/filter.js